import React from 'react';

import { SpinnerNew as Spinner } from '~/App/Components/Shared/Spinner';
import ArrowButton from '~/App/Components/QuestionnaireCard/ResponseSection/ArrowButton';
import { useTranslation } from 'react-i18next';
import { Button, ButtonVariant } from '@vimily/bonjoro-ui-components-v2/Button';
import { computeTextColor } from '@vimily/bonjoro-ui-components-v2';

export interface AttachmentCardButtonsProps {
  nextDisabled?: boolean;
  loading?: boolean;
  onNextClick?: () => void;
  onPreviousClick?: () => void;
  ctaCornerRadius?: number;
  ctaColor?: string;
  fontFamily?: string;
}

export default function AttachmentCardButtons({
  nextDisabled = false,
  loading = false,
  onNextClick,
  onPreviousClick,
  ctaCornerRadius = 0,
  ctaColor,
  fontFamily
}: AttachmentCardButtonsProps) {
  const { t } = useTranslation();

  const buttonProps = {
    className: 'px-4',
    variant: ButtonVariant.Primary,
    onClick: onNextClick,
    disabled: nextDisabled,
    style: {
      borderRadius: `${ctaCornerRadius}px`,
      borderColor: ctaColor,
      backgroundColor: ctaColor,
      color: computeTextColor(ctaColor),
      fontFamily
    }
  };

  return (
    <div className='hidden md:!flex mt-auto justify-between'>
      <div className='flex flex-row'>
        <ArrowButton className='rounded-r-none' onClick={onPreviousClick}>
          <i className='fa fa-chevron-up' />
        </ArrowButton>
        <ArrowButton
          className='rounded-l-none'
          disabled={nextDisabled}
          onClick={onNextClick}
        >
          <i className='fa fa-chevron-down' />
        </ArrowButton>
      </div>
      <Button {...buttonProps} >
        {t('testimonial:response.next')} {loading && <Spinner />}
      </Button>
    </div>
  );
}
